import React, { useRef } from 'react'
import { PropTypes } from 'prop-types'
import { useHistory } from 'react-router-dom'

const InternalLink = (props) => {

    const { elementId, to, className, onClick, children, useLinkBehavior } = props
    const history = useHistory()
    const linkRef = useRef(null);

    const isRightButton = e => {
        var isRightMB;
        e = e || window.event;

        if ("which" in e)  // Gecko (Firefox), WebKit (Safari/Chrome) & Opera
            isRightMB = e.which === 3
        else if ("button" in e)  // IE, Opera 
            isRightMB = e.button === 2

        return isRightMB
    }

    const linkClicked = (e) => {
        if (!isRightButton(e) && !e.ctrlKey) {
            e.preventDefault()
            e.stopPropagation();
            if (!!to) {
                history.push(to)
            }
            if (onClick) onClick(e)

            return false;
        }
    }

    return useLinkBehavior ?
        (<a id={elementId} ref={linkRef} className={className} onMouseDown={linkClicked} href={to}>{children}</a>) :
        (<a id={elementId} ref={linkRef} className={className} onMouseDown={linkClicked}>{children}</a>)
}

InternalLink.propTypes = {
    to: PropTypes.string,
    elementId: PropTypes.string.isRequired,
    onClick: PropTypes.func,
    className: PropTypes.string,
    useLinkBehavior: PropTypes.bool
}

export default InternalLink